import { render, staticRenderFns } from "./menu-sidebar.vue?vue&type=template&id=21093600&"
import script from "./menu-sidebar.vue?vue&type=script&lang=js&"
export * from "./menu-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports